import { ReactNode } from "react";
import { IDeviceStateControllerReturn } from "../../../../../../commonreact/main/services/devicestate/DeviceStateController";

export interface ICardProps {
  hideHeader?: boolean;
  hideHeaderLine?: boolean;
  addClassName?: string,
  addChildrenClassName?: string;
  header?: ReactNode;
  headerNodePre?: ReactNode;
  headerNode?: ReactNode;
  children?: ReactNode;
  dsc: IDeviceStateControllerReturn;
}

export default function CardWrapper(props: ICardProps) {
  return (
    <div
      id="card"
      className={`w-full overflow-visible flex flex-col
      ${props.header ? "m-0 rounded-lg bg-gray-900 shadow" : ""}
      ${(props.dsc.small || props.dsc.isMobile) ? "my-2 p-0" : "my-6 p-6"} ${props.addClassName ? props.addClassName : ""}`}
    >
      {!props.hideHeader ?
        <div className={"w-full flex flex-col py-2 pl-2 pr-2 pt-2 pb-0 mb-0"}>
          <div className="w-full flex-row">
            {props.headerNodePre ? <div className="p-2 float-left w-auto">{props.headerNodePre}</div> : <></>}
            {props.header ? <div className="pt-2 pb-2 float-left w-auto"><div className={"font-bold mb-0"}>{props.header}</div></div> : <></>}
            {props.headerNode ? <div className="p-2 float-right w-auto">{props.headerNode}</div> : <></>}
          </div>
          {(props.header && !props.hideHeaderLine) ? <hr className={"mx-0 mt-0 border-current"} /> : <></>}
        </div> : <></>}

      <div className={`${props.dsc.small?"p-2":"px-2 py-2"} : ""} ${props.addChildrenClassName?props.addChildrenClassName:"w-full"}`}>{props.children}</div>
    </div>
  );
}